import React from 'react';
import styles from './Permits.module.scss';
import usePermits from '../../shared/api/usePermits';
import { Spin } from 'antd';
import EmptyCard from '../../shared/ui/EmptyCard/EmptyCard';
import PermitsBlock from './components/PermitsBlock/PermitsBlock';
import useGetParamsForRequest from '../../shared/hooks/useGetParamsForRequest';
import FilterDrawerPermits from './components/FilterDrawerPermits/FilterDrawerPermits';
import { useSelector } from 'react-redux';
import useFilteredBySearchDataTransportPermits from '../../shared/hooks/useFilteredBySearchDataTransportPermits';
import { modes } from '../../shared/components/Search/constants';
import LimitsPermitModal from './components/LimitsPermitModal/LimitsPermitModal';

const Permits = () => {
  const paramsRequest = useGetParamsForRequest();

  const filterChanged = useSelector(
    (state) => state.permitsFilterStore.filterChanged
  );

  const { data: permits = [], isFetching } = usePermits(paramsRequest, {
    enabled: !filterChanged,
    keepPreviousData: true,
  });

  const isEmpty = !permits || !permits?.length;

  const [loading, filteredBySearchPermits] =
    useFilteredBySearchDataTransportPermits({
      data: permits,
      mode: modes.permits,
    });

  return (
    <Spin spinning={isFetching || loading}>
      <article className={styles.container}>
        <div className={styles.root}>
          {isEmpty ? (
            <EmptyCard description="По указанным параметрам пропусков не найдено" />
          ) : (
            <PermitsBlock filteredBySearchPermits={filteredBySearchPermits} />
          )}
        </div>
      </article>
      <FilterDrawerPermits />
      <LimitsPermitModal />
    </Spin>
  );
};

export default Permits;
